import Seo from "../components/Seo";
import React, { useState } from "react";
import { api } from "../lib/api";
import { MEDIA } from "../lib/media";
import { Palette, Send, CheckCircle2, Brush, Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";

export default function Portrait() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/inquiries", { ...form, type: "portrait" }); setDone(true); toast.success("Запитването е изпратено!"); }
    catch { toast.error("Възникна грешка."); }
  };

  return (
    <div data-testid="portrait-page">
      <Seo title="Портрети по поръчка" path="/portreti" description="Поръчайте уникален портрет по снимка с маслени или акрилни бои. Над 150 нарисувани портрета от художник Силва Пенева. Идеален подарък." />
      <section className="relative bg-navy text-ivory">
        <img src={MEDIA.artist} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 py-16 md:py-24 text-center">
          <Palette size={36} className="text-gold mx-auto mb-5" strokeWidth={1.3} />
          <h1 className="font-serif text-4xl md:text-5xl text-white">Портрети по поръчка</h1>
          <p className="text-ivory/85 mt-4 max-w-2xl mx-auto text-lg">
            Над <b className="text-gold">150 портрета</b> с маслени и акрилни бои. Изпратете снимка и ще създадем уникален портрет за вас или като подарък.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 grid lg:grid-cols-2 gap-10">
        <div>
          <h2 className="font-serif text-3xl text-navy">Как се поръчва портрет?</h2>
          <div className="gold-line my-5" />
          {[
            { icon: ImageIcon, t: "1. Изпратете снимка", d: "Прикачете или опишете желаната снимка и размер." },
            { icon: Brush, t: "2. Изработка на ръка", d: "Силва Пенева рисува портрета с маслени или акрилни бои." },
            { icon: Palette, t: "3. Доставка до адрес", d: "Получавате готовия портрет, внимателно опакован." },
          ].map((s) => (
            <div key={s.t} className="flex gap-4 mb-5">
              <div className="w-11 h-11 border border-gold flex items-center justify-center text-gold shrink-0"><s.icon size={20} /></div>
              <div><h3 className="font-serif text-lg text-navy">{s.t}</h3><p className="text-sm text-charcoal/65">{s.d}</p></div>
            </div>
          ))}
        </div>

        {done ? (
          <div className="bg-white border border-stone p-8 flex flex-col items-center justify-center text-center" data-testid="portrait-success">
            <CheckCircle2 size={48} className="text-gold mb-4" strokeWidth={1.2} />
            <h3 className="font-serif text-2xl text-navy">Благодарим!</h3>
            <p className="text-charcoal/60 mt-2">Получихме запитването ви за портрет и ще се свържем с вас скоро.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-stone p-6 space-y-4" data-testid="portrait-form">
            <h2 className="font-serif text-2xl text-navy">Запитване за портрет</h2>
            <input required placeholder="Вашето име" value={form.name} onChange={set("name")} className="w-full border border-stone px-4 py-3 outline-none focus:border-gold" data-testid="portrait-name" />
            <input required type="email" placeholder="Имейл" value={form.email} onChange={set("email")} className="w-full border border-stone px-4 py-3 outline-none focus:border-gold" data-testid="portrait-email" />
            <input placeholder="Телефон" value={form.phone} onChange={set("phone")} className="w-full border border-stone px-4 py-3 outline-none focus:border-gold" data-testid="portrait-phone" />
            <textarea required placeholder="Опишете желания портрет – брой лица, размер, стил, повод..." rows={5} value={form.message} onChange={set("message")} className="w-full border border-stone px-4 py-3 outline-none focus:border-gold" data-testid="portrait-message" />
            <button type="submit" className="btn-gold w-full py-3.5 rounded-sm flex items-center justify-center gap-2" data-testid="portrait-submit"><Send size={16} /> Изпрати запитване</button>
          </form>
        )}
      </section>
    </div>
  );
}
